export default "__VITE_PUBLIC_ASSET__fd31f3fc__"